import React from 'react'
import { Col, Row } from 'antd'
import { Picker } from './Picker'
import { Shortcuts } from './Shortcuts'
import { RangeValue } from 'rc-picker/lib/interface'
import { Moment } from 'moment'

type Props = {
  ranges?: RangeValue<Moment>
  setRanges: (values: RangeValue<Moment>) => void
}

export const View: React.FunctionComponent<Props> = ({ ranges, setRanges }) => {
  return (
    <>
      <Row gutter={[32, 0]}>
        <Col span={14}>
          <Picker ranges={ranges} setRanges={setRanges} />
        </Col>
        <Col span={10}>
          <Shortcuts ranges={ranges} setRanges={setRanges} />
        </Col>
      </Row>
    </>
  )
}
